(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('loadingScreenNumbers', function(arrayUtil) {
    return {
        restrict: 'E',
        template: '<span></span>',
        scope: { chars: '=' },
        link(scope, el) {
            if (scope.chars) {
                el.html(arrayUtil.map(scope.chars, function(c) {
                    return `<span class="number-image c-${c}"></span>`;
                }).join(''));
            }
        }
    };
});
})();
